module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_dokfeltoltes3.b8177faf.jpg";